const SVGSprites = () => {
  return (
    <svg className="hidden">
      <symbol id="menu-icon" viewBox="0 0 20 20">
        <rect
          x="9"
          y="8"
          width="8"
          height="2"
          rx="1"
          transform="rotate(-90 9 8)"
        />
        <rect y="9" width="8" height="2" rx="1" />
        <rect x="12" y="9" width="8" height="2" rx="1" />
        <rect
          x="9"
          y="20"
          width="8"
          height="2"
          rx="1"
          transform="rotate(-90 9 20)"
        />
      </symbol>

      <symbol id="search-icon" viewBox="0 0 16 16">
        <path
          d="M7.66665 14C11.1644 14 14 11.1645 14 7.66667C14 4.16886 11.1644 1.33333 7.66665 1.33333C4.16884 1.33333 1.33331 4.16886 1.33331 7.66667C1.33331 11.1645 4.16884 14 7.66665 14Z"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.6666 14.6667L13.3333 13.3333"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </symbol>

      <symbol id="close-icon" viewBox="0 0 14 14">
        <rect
          x="2.05029"
          y="0.63604"
          width="16"
          height="2"
          rx="1"
          transform="rotate(45 2.05029 0.63604)"
        />
        <rect
          x="0.63623"
          y="11.9498"
          width="16"
          height="2"
          rx="1"
          transform="rotate(-45 0.63623 11.9498)"
        />
      </symbol>

      <symbol id="arrow-right-icon" viewBox="0 0 6 11">
        <path
          d="M0.292893 1.16887C0.683417 0.778345 1.31658 0.778345 1.70711 1.16887L5.70711 5.16887C6.09763 5.55939 6.09763 6.19256 5.70711 6.58308C5.31658 6.97361 4.68342 6.97361 4.29289 6.58308L0.292893 2.58308C-0.0976311 2.19256 -0.0976311 1.55939 0.292893 1.16887Z"
          fillRule="evenodd"
          clipRule="evenodd"
        />
        <path
          d="M0.292893 10.5831C0.683417 10.9736 1.31658 10.9736 1.70711 10.5831L5.70711 6.58308C6.09763 6.19256 6.09763 5.55939 5.70711 5.16887C5.31658 4.77835 4.68342 4.77835 4.29289 5.16887L0.292893 9.16887C-0.0976311 9.55939 -0.0976311 10.1926 0.292893 10.5831Z"
          fillRule="evenodd"
          clipRule="evenodd"
        />
      </symbol>

      <symbol id="arrow-down-icon" viewBox="0 0 15 10">
        <path
          d="M0.43934 9.06066C-0.146447 8.47487 -0.146447 7.52513 0.43934 6.93934L6.43934 0.939341C7.02513 0.353554 7.97487 0.353554 8.56066 0.939341C9.14645 1.52513 9.14645 2.47487 8.56066 3.06066L2.56066 9.06066C1.97487 9.64645 1.02513 9.64645 0.43934 9.06066Z"
          fillRule="evenodd"
          clipRule="evenodd"
        />
        <path
          d="M14.5607 9.06066C15.1464 8.47487 15.1464 7.52513 14.5607 6.93934L8.56066 0.939341C7.97487 0.353554 7.02513 0.353554 6.43934 0.939341C5.85355 1.52513 5.85355 2.47487 6.43934 3.06066L12.4393 9.06066C13.0251 9.64645 13.9749 9.64645 14.5607 9.06066Z"
          fillRule="evenodd"
          clipRule="evenodd"
        />
      </symbol>

      <symbol id="play-icon" viewBox="0 0 60 60">
        <path d="M36.525 28.7421C37.1373 29.1357 37.1373 30.0308 36.525 30.4244L25.7631 37.3428C25.0976 37.7706 24.2224 37.2928 24.2224 36.5016L24.2224 22.6649C24.2224 21.8738 25.0976 21.3959 25.7631 21.8237L36.525 28.7421Z" />
      </symbol>

      <symbol id="paypal-icon" viewBox="0 0 17 20">
        <path
          d="M14.0809 4.58442C14.1292 2.07337 12.0572 0.145744 9.20814 0.145744H3.31607C3.17872 0.145789 3.0459 0.194853 2.94151 0.284107C2.83712 0.373361 2.76801 0.496943 2.74663 0.632614L0.385378 15.3858C0.374816 15.4526 0.378866 15.521 0.39725 15.5861C0.415634 15.6513 0.447916 15.7116 0.491872 15.7631C0.535828 15.8146 0.590415 15.8559 0.651874 15.8842C0.713332 15.9126 0.780203 15.9272 0.847882 15.9273H4.33899L3.79301 19.3439C3.78244 19.4108 3.7865 19.4792 3.80492 19.5444C3.82333 19.6095 3.85565 19.6699 3.89965 19.7214C3.94366 19.7729 3.9983 19.8142 4.05982 19.8425C4.12133 19.8708 4.18825 19.8854 4.25597 19.8854H7.09957C7.2372 19.8854 7.35948 19.8358 7.46371 19.7469C7.56794 19.6575 7.58509 19.5343 7.6063 19.3985L8.44106 14.487C8.46227 14.3516 8.5313 14.1756 8.63599 14.0863C8.74022 13.9969 8.83137 13.9482 8.96854 13.9477H10.7094C13.4993 13.9477 15.8668 11.9651 16.2996 9.20675C16.6055 7.24844 15.7658 5.46747 14.0809 4.58442Z"
          fill="#001C64"
        />
        <path
          d="M5.09432 10.4864L4.22481 16.0004L3.67883 19.4585C3.66827 19.5254 3.67233 19.5938 3.69074 19.659C3.70915 19.7241 3.74147 19.7845 3.78548 19.836C3.82948 19.8875 3.88412 19.9288 3.94564 19.9571C4.00715 19.9854 4.07407 20 4.14179 20H7.15145C7.28871 19.9998 7.42143 19.9507 7.52572 19.8615C7.63002 19.7722 7.69906 19.6487 7.72044 19.5131L8.51369 14.4865C8.53507 14.351 8.60413 14.2275 8.70844 14.1383C8.81275 14.0491 8.94545 14.0001 9.08268 14.0001H10.8546C13.6445 14.0001 16.0117 11.9651 16.4444 9.20675C16.7512 7.24889 15.7657 5.46792 14.0809 4.58442C14.0764 4.79289 14.0583 5.0009 14.0263 5.20711C13.5936 7.96498 11.226 10.0005 8.43608 10.0005H5.66331C5.52615 10.0005 5.3935 10.0494 5.2892 10.1385C5.1849 10.2276 5.1158 10.3509 5.09432 10.4864Z"
          fill="#0070E0"
        />
        <path
          d="M4.22433 16.0004H0.722837C0.655134 16.0004 0.588226 15.9858 0.526729 15.9575C0.465233 15.9292 0.410614 15.8878 0.366642 15.8363C0.32267 15.7849 0.290393 15.7245 0.272039 15.6593C0.253685 15.5941 0.249691 15.5258 0.260333 15.4589L2.62113 0.486418C2.64253 0.350791 2.71165 0.227262 2.81605 0.138083C2.92045 0.0489031 3.05327 -6.45301e-05 3.19057 6.38234e-08H9.20853C12.0571 6.38234e-08 14.1291 2.07337 14.0808 4.58442C13.372 4.21262 12.539 4.00009 11.6262 4.00009H6.60904C6.47184 4.00022 6.33918 4.04927 6.23489 4.13843C6.1306 4.22758 6.06152 4.351 6.04005 4.48651L5.09473 10.4864L4.22433 16.0004Z"
          fill="#003087"
        />
      </symbol>

      <symbol id="phone-icon" viewBox="0 0 17 16">
        <path
          d="M15.1466 12.22C15.1466 12.46 15.0933 12.7066 14.98 12.9466C14.8666 13.1866 14.72 13.4133 14.5266 13.6266C14.2 13.9866 13.84 14.2466 13.4333 14.4133C13.0333 14.58 12.6 14.6666 12.1333 14.6666C11.4533 14.6666 10.7266 14.5066 9.95998 14.18C9.19331 13.8533 8.42665 13.4133 7.66665 12.86C6.89998 12.3 6.17331 11.68 5.47998 10.9933C4.79331 10.3 4.17331 9.57331 3.61998 8.81331C3.07331 8.05331 2.63331 7.29331 2.31331 6.53998C1.99331 5.77998 1.83331 5.05331 1.83331 4.35998C1.83331 3.90665 1.91331 3.47331 2.07331 3.07331C2.23331 2.66665 2.48665 2.29331 2.83998 1.95998C3.26665 1.53998 3.73331 1.33331 4.22665 1.33331C4.41331 1.33331 4.59998 1.37331 4.76665 1.45331C4.93998 1.53331 5.09331 1.65331 5.21331 1.82665L6.75998 4.00665C6.87998 4.17331 6.96665 4.32665 7.02665 4.47331C7.08665 4.61331 7.11998 4.75331 7.11998 4.87998C7.11998 5.03998 7.07331 5.19998 6.97998 5.35331C6.89331 5.50665 6.76665 5.66665 6.60665 5.82665L6.09998 6.35331C6.02665 6.42665 5.99331 6.51331 5.99331 6.61998C5.99331 6.67331 5.99998 6.71998 6.01331 6.77331C6.03331 6.82665 6.05331 6.86665 6.06665 6.90665C6.18665 7.12665 6.39331 7.41331 6.68665 7.75998C6.98665 8.10665 7.30665 8.45998 7.65331 8.81331C8.01331 9.16665 8.35998 9.49331 8.71331 9.79331C9.05998 10.0866 9.34665 10.2866 9.57331 10.4066C9.60665 10.42 9.64665 10.44 9.69331 10.46C9.74665 10.48 9.79998 10.4866 9.85998 10.4866C9.97331 10.4866 10.06 10.4466 10.1333 10.3733L10.64 9.87331C10.8066 9.70665 10.9666 9.57998 11.12 9.49998C11.2733 9.40665 11.4266 9.35998 11.5933 9.35998C11.72 9.35998 11.8533 9.38665 12 9.44665C12.1466 9.50665 12.3 9.59331 12.4666 9.70665L14.6733 11.2733C14.8466 11.3933 14.9666 11.5333 15.04 11.7C15.1066 11.8666 15.1466 12.0333 15.1466 12.22Z"
          stroke="currentColor"
          strokeMiterlimit="10"
          fill="none"
        />
        <path
          d="M12.8333 6.00002C12.8333 5.60002 12.52 4.98669 12.0533 4.48669C11.6267 4.02669 11.06 3.66669 10.5 3.66669"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M15.1667 5.99998C15.1667 3.41998 13.08 1.33331 10.5 1.33331"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </symbol>

      <symbol id="people-icon" viewBox="0 0 17 16">
        <path
          d="M12.5 4.77332C12.46 4.76665 12.4133 4.76665 12.3733 4.77332C11.4533 4.73998 10.72 3.98665 10.72 3.05331C10.72 2.09998 11.4866 1.33331 12.44 1.33331C13.3933 1.33331 14.16 2.10665 14.16 3.05331C14.1533 3.98665 13.42 4.73998 12.5 4.77332Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M11.8133 9.62669C12.7267 9.78003 13.7333 9.62003 14.44 9.14669C15.38 8.52003 15.38 7.49336 14.44 6.86669C13.7267 6.39336 12.7067 6.23336 11.7933 6.39336"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M4.48001 4.77332C4.52001 4.76665 4.56667 4.76665 4.60667 4.77332C5.52667 4.73998 6.26001 3.98665 6.26001 3.05331C6.26001 2.09998 5.49334 1.33331 4.54001 1.33331C3.58668 1.33331 2.82001 2.10665 2.82001 3.05331C2.82667 3.98665 3.56001 4.73998 4.48001 4.77332Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M5.16669 9.62669C4.25335 9.78003 3.24669 9.62003 2.54002 9.14669C1.60002 8.52003 1.60002 7.49336 2.54002 6.86669C3.25336 6.39336 4.27335 6.23336 5.18669 6.39336"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M8.49997 9.7533C8.45997 9.74663 8.4133 9.74663 8.3733 9.7533C7.4533 9.71996 6.71997 8.96663 6.71997 8.03329C6.71997 7.07996 7.48664 6.31329 8.43997 6.31329C9.3933 6.31329 10.16 7.08663 10.16 8.03329C10.1533 8.96663 9.41997 9.72663 8.49997 9.7533Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M6.55998 11.8533C5.61998 12.48 5.61998 13.5066 6.55998 14.1333C7.62665 14.8466 9.37331 14.8466 10.44 14.1333C11.38 13.5066 11.38 12.48 10.44 11.8533C9.37998 11.1466 7.62665 11.1466 6.55998 11.8533Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </symbol>

      <symbol id="email-icon" viewBox="0 0 16 16">
        <path
          d="M11.3333 13.6668H4.66665C2.66665 13.6668 1.33331 12.6668 1.33331 10.3335V5.66683C1.33331 3.3335 2.66665 2.3335 4.66665 2.3335H11.3333C13.3333 2.3335 14.6666 3.3335 14.6666 5.66683V10.3335C14.6666 12.6668 13.3333 13.6668 11.3333 13.6668Z"
          stroke="currentColor"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M11.3334 6L9.24668 7.66667C8.56002 8.21333 7.43335 8.21333 6.74668 7.66667L4.66669 6"
          stroke="currentColor"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </symbol>

      <symbol id="facebook-icon" viewBox="0 0 44 44">
        <path
          d="M24.5556 18.7333H22.9778C22.8741 18.7333 22.7815 18.7889 22.7 18.9C22.6185 19.0111 22.5778 19.1481 22.5778 19.3111V20.4444H24.5556V22.0889H22.5778V27H20.6889V22.0889H19V20.4444H20.6889V19.4889C20.6889 18.7926 20.9074 18.2037 21.3444 17.7222C21.7815 17.2407 22.3259 17 22.9778 17H24.5556V18.7333Z"
          fill="currentColor"
          fillRule="evenodd"
          clipRule="evenodd"
        />
      </symbol>

      <symbol id="instagram-icon" viewBox="0 0 44 44">
        <path
          d="M27.9441 24.4755C27.972 24.0186 27.986 23.1935 27.986 22C27.986 20.8065 27.972 19.9814 27.9441 19.5245C27.8881 18.4336 27.5664 17.5944 26.979 17.007C26.3916 16.4196 25.5571 16.0979 24.4755 16.042C24.0186 16.014 23.1935 16 22 16C20.8065 16 19.9814 16.014 19.5245 16.042C18.4429 16.0886 17.6037 16.4103 17.007 17.007C16.4103 17.6037 16.0886 18.4429 16.042 19.5245C16.014 19.9814 16 20.8065 16 22C16 23.1935 16.014 24.0186 16.042 24.4755C16.0886 25.5664 16.4103 26.4056 17.007 26.993C17.6037 27.5804 18.4429 27.9021 19.5245 27.958C19.9907 27.986 20.8158 28 22 28C23.1842 28 24.0093 27.986 24.4755 27.958C25.5478 27.9114 26.3823 27.5897 26.979 26.993C27.5758 26.3963 27.8974 25.5571 27.9441 24.4755ZM22.0004 17.0769H20.5738C20.3873 17.0769 20.1356 17.0862 19.8186 17.1049C19.5015 17.1235 19.2358 17.1468 19.0214 17.1748C18.8069 17.2028 18.6204 17.2541 18.4619 17.3287C18.2008 17.4312 17.9724 17.5804 17.7766 17.7762C17.5808 17.972 17.427 18.2005 17.3151 18.4615C17.2591 18.6107 17.2125 18.7972 17.1752 19.021C17.1379 19.2447 17.1099 19.5151 17.0913 19.8322C17.0726 20.1492 17.068 20.3963 17.0773 20.5734C17.0866 20.7506 17.0866 21.0256 17.0773 21.3986C17.068 21.7716 17.068 21.972 17.0773 22C17.0866 22.028 17.0866 22.2284 17.0773 22.6014C17.068 22.9744 17.068 23.2494 17.0773 23.4266C17.0866 23.6037 17.0913 23.8508 17.0913 24.1678C17.0913 24.4848 17.1193 24.7552 17.1752 24.979L17.3151 25.5385C17.427 25.7995 17.5808 26.028 17.7766 26.2238C17.9724 26.4196 18.2008 26.5688 18.4619 26.6713C18.6111 26.7273 18.7976 26.7785 19.0214 26.8252C19.2451 26.8718 19.5109 26.8951 19.8186 26.8951C20.1263 26.8951 20.378 26.9044 20.5738 26.9231C20.7696 26.9417 21.0447 26.9417 21.399 26.9231C21.7533 26.9044 21.9538 26.9044 22.0004 26.9231C22.047 26.9417 22.2428 26.9417 22.5878 26.9231C22.9328 26.9044 23.2078 26.9044 23.413 26.9231C23.6181 26.9417 23.8698 26.9324 24.1682 26.8951C24.4666 26.8578 24.737 26.8345 24.9794 26.8252C25.2218 26.8158 25.4036 26.7646 25.5249 26.6713C25.7859 26.5688 26.019 26.4196 26.2242 26.2238C26.4293 26.028 26.5785 25.7995 26.6717 25.5385C26.7277 25.3893 26.7743 25.2028 26.8116 24.979C26.8489 24.7552 26.8768 24.4848 26.8955 24.1678C26.9141 23.8508 26.9188 23.6037 26.9095 23.4266C26.9001 23.2494 26.9001 22.9744 26.9095 22.6014C26.9188 22.2284 26.9188 22.028 26.9095 22C26.9001 21.972 26.9001 21.7716 26.9095 21.3986C26.9188 21.0256 26.9188 20.7506 26.9095 20.5734C26.9001 20.3963 26.8955 20.1492 26.8955 19.8322C26.8955 19.5151 26.8675 19.2447 26.8116 19.021L26.6717 18.4615C26.5691 18.2005 26.42 17.972 26.2242 17.7762C26.0284 17.5804 25.7953 17.4312 25.5249 17.3287C25.3757 17.2727 25.1939 17.2214 24.9794 17.1748C24.7649 17.1282 24.4946 17.1049 24.1682 17.1049C23.8419 17.1049 23.5901 17.0956 23.413 17.0769C23.2358 17.0583 22.9608 17.0583 22.5878 17.0769C22.2148 17.0956 22.019 17.0956 22.0004 17.0769ZM25.7063 19.3007C25.8462 19.1608 25.9161 18.993 25.9161 18.7972C25.9347 18.6014 25.8648 18.4336 25.7063 18.2937C25.5478 18.1538 25.3753 18.0839 25.1888 18.0839C25.0023 18.0839 24.8345 18.1538 24.6853 18.2937C24.5361 18.4336 24.4662 18.6014 24.4755 18.7972C24.4848 18.993 24.5548 19.1608 24.6853 19.3007C24.8159 19.4406 24.9837 19.5105 25.1888 19.5105C25.3939 19.5105 25.5664 19.4406 25.7063 19.3007ZM25.0629 22C25.0629 22.8485 24.7646 23.5758 24.1678 24.1818C23.5711 24.7879 22.8485 25.0862 22 25.0769C21.1515 25.0676 20.4242 24.7692 19.8182 24.1818C19.2121 23.5944 18.9138 22.8671 18.9231 22C18.9324 21.1329 19.2308 20.4056 19.8182 19.8182C20.4056 19.2308 21.1329 18.9324 22 18.9231C22.8671 18.9138 23.5897 19.2121 24.1678 19.8182C24.7459 20.4242 25.0443 21.1515 25.0629 22ZM23.9863 22C23.9863 21.4499 23.7952 20.979 23.4129 20.5874C23.0306 20.1958 22.5598 20 22.0003 20C21.4409 20 20.97 20.1958 20.5877 20.5874C20.2054 20.979 20.0096 21.4499 20.0003 22C19.991 22.5501 20.1868 23.021 20.5877 23.4126C20.9887 23.8042 21.4595 24 22.0003 24C22.5411 24 23.012 23.8042 23.4129 23.4126C23.8138 23.021 24.005 22.5501 23.9863 22Z"
          fill="currentColor"
          fillRule="evenodd"
          clipRule="evenodd"
        />
      </symbol>

      <symbol id="twitter-icon" viewBox="0 0 44 44">
        <path
          d="M25.4533 16H27.48L23.0533 21.0933L28.28 28H24.1733L20.9733 23.8133L17.2933 28H15.2667L20.0133 22.56L15 16H19.2133L22.12 19.84L25.4533 16ZM24.7333 26.7733H25.8533L18.6 17.1467H17.3733L24.7333 26.7733Z"
          fill="currentColor"
        />
      </symbol>

      <symbol id="youtube-icon" viewBox="0 0 44 44">
        <path
          d="M19.7975 24.5325V19.4675L24.2645 22.0001L19.7975 24.5325ZM29.7337 17.8738C29.5372 17.1362 28.9581 16.5554 28.2228 16.3583C26.89 16 21.5455 16 21.5455 16C21.5455 16 16.201 16 14.8681 16.3583C14.1328 16.5554 13.5537 17.1362 13.3571 17.8738C13 19.2107 13 22 13 22C13 22 13 24.7893 13.3571 26.1262C13.5537 26.8638 14.1328 27.4446 14.8681 27.6418C16.201 28 21.5455 28 21.5455 28C21.5455 28 26.89 28 28.2228 27.6418C28.9581 27.4446 29.5372 26.8638 29.7337 26.1262C30.0909 24.7893 30.0909 22 30.0909 22C30.0909 22 30.0909 19.2107 29.7337 17.8738Z"
          fill="currentColor"
        />
      </symbol>

      <symbol id="linkedin-icon" viewBox="0 0 44 44">
        <path
          d="M19.3025 18.0835C19.3025 18.3845 19.1934 18.6403 18.9752 18.851C18.757 19.0617 18.4786 19.167 18.14 19.167C17.8014 19.167 17.5267 19.0617 17.316 18.851C17.1053 18.6403 17 18.3807 17 18.0722C17 17.7637 17.1053 17.5079 17.316 17.3047C17.5267 17.1016 17.8051 17 18.1512 17C18.4974 17 18.772 17.1016 18.9752 17.3047C19.1783 17.5079 19.2874 17.7675 19.3025 18.0835ZM17.0674 27V20.0248H19.2344V27H17.0674ZM20.4766 20.0248C20.5067 20.8676 20.5217 21.6125 20.5217 22.2596V27H22.7113V22.9819C22.7113 22.7111 22.7339 22.5305 22.779 22.4402C22.9897 21.8984 23.3584 21.6275 23.8851 21.6275C24.6225 21.6275 24.9912 22.1317 24.9912 23.14V27H27.1583V22.8691C27.1583 21.8758 26.9288 21.1272 26.4698 20.623C26.0108 20.1189 25.4051 19.8668 24.6526 19.8668C23.6745 19.8668 22.9596 20.243 22.5082 20.9955H22.463L22.3502 20.0248H20.4766Z"
          fill="currentColor"
          fillRule="evenodd"
          clipRule="evenodd"
        />
      </symbol>
    </svg>
  )
}

export default SVGSprites
